import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import PlatformCashBackAuditEdit from '../edit/index';
export default {
  name: 'PlatformCashBackAuditList',
  components: {
    PlatformCashBackAuditEdit: PlatformCashBackAuditEdit
  },
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('platform_cash_back_audit_select'),
      isCreate: this.checkauthority('platform_cash_back_audit_create'),
      isUpdate: this.checkauthority('platform_cash_back_audit_heshi'),
      isDelete: this.checkauthority('platform_cash_back_audit_delete'),
      isChuli: this.checkauthority('platform_cash_back_audit_chuli'),
      selectForm: {
        createTimes: [],
        createTime: null,
        memberNo: '',
        stats: '0'
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      sumDataCount: {
        todyYearDataCount: 0,
        lastYearDataCount: 0,
        sumDataCount: 0
      },
      stats: [],
      selectStats: []
    };
  },
  methods: {
    statsChange: function statsChange(op) {
      if (op === '') {
        this.selectForm.stats = '0';
      }
    },
    checkStatsDisabled: function checkStatsDisabled(item) {
      if (item.stats === 2) {
        return true;
      }
      return false;
    },
    checkIsDel: function checkIsDel(item) {
      if (item.isDel === 1) {
        return '恢复';
      } else {
        return '删除';
      }
    },
    checkStats: function checkStats(item) {
      return this.enums.checkEnumsValue(this.stats, item.stats + '', '');
    },
    getImagesImage: function getImagesImage(row) {
      var url = JSON.parse(row.images)[0].url;
      return this.downloadUrl + url;
    },
    getImagesImages: function getImagesImages(row) {
      var _this = this;
      var images = JSON.parse(row.images);
      var urls = [];
      images.forEach(function (img) {
        urls.push(_this.downloadUrl + img.url);
      });
      return urls;
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.getCashBankAuditStats(function (result) {
        thiz.stats = result.body;
        for (var i in thiz.stats) {
          var item = thiz.stats[i];
          if (item.keys !== '已处理') {
            thiz.selectStats.push(item);
          }
        }
      });
    },
    handle: function handle(index, data, stats, msg) {
      var _this2 = this;
      this.$confirm('此操作将' + msg + '处理该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.handleApi(index, data, stats);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    handleApi: function handleApi(index, data, stats) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                auditCashBackId: data.auditCashBackId,
                stats: stats
              };
              _context.n = 1;
              return api.UPDATE_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _this3.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      var msg = '删除';
      if (data.isDel === 1) {
        msg = '恢复';
      }
      this.$confirm('此操作将永久' + msg + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                auditCashBackId: data.auditCashBackId
              };
              if (data.isDel === 1) {
                par.isDel = 0;
              } else {
                par.isDel = 1;
              }
              _context2.n = 1;
              return api.UPDATE_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.DELETE_BATCH_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _this6.$message.success('操作成功');
              _this6.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getSumDataCount: function getSumDataCount() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_PLATFORMCASHBACKAUDIT_SUM_DATA_COUNT();
            case 1:
              res = _context4.v;
              _this7.sumDataCount = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this8 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this8.tableSelects.forEach(function (element) {
          par.push(element.auditCashBackId);
        });
        _this8.deleteBatchApi(par);
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTime = null;
      this.selectForm.memberNo = '';
      this.selectForm.createTimes = [];
      this.selectForm.stats = '0';
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this9.pageNo,
                pageSize: _this9.pageSize,
                createTime: _this9.selectForm.createTime,
                memberNo: _this9.selectForm.memberNo,
                isDel: 0
              };
              if (_this9.selectForm.stats !== '3') {
                par.stats = _this9.selectForm.stats;
              } else if (_this9.selectForm.stats === '3') {
                par.isDel = 1;
              }
              if (_this9.selectForm.createTimes.length >= 2) {
                par.createStartTime = _this9.selectForm.createTimes[0];
                par.createEndTime = _this9.selectForm.createTimes[1];
              }
              _context5.n = 1;
              return api.GET_PLATFORMCASHBACKAUDIT_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this9.tableData = res.body.datas;
              _this9.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initEunmData();
    this.initTableData();
  }
};